module.exports = __webpack_public_path__ + "img/icon-google.7a8e3201.svg";